import { useEffect } from "react";

export const useSeo = (title, description) => {
  useEffect(() => {
    const prevTitle = document.title;
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    const prevDesc = meta.getAttribute("content");
    document.title = title;
    meta.setAttribute("content", description);
    return () => {
      document.title = prevTitle;
      meta.setAttribute("content", prevDesc || "");
    };
  }, [title, description]);
};
